module.exports = __webpack_public_path__ + "media/images/lb/735-0ab7d14e8f73f75a24a2f8d2aa529f3e.svg";